import React from "react";
import {
	Grid,
	Button,
	IconButton,
} from "@mui/material";
import {
	makeStyles
} from "@mui/styles";
import {
	AddCircle as AddCircleIcon
} from "@mui/icons-material";
import getTrans from "../../../languages/getTrans";
import rateConvert from "../../../utils/rateConvert";
import {useSelector} from "react-redux";
import {Link} from "react-router-dom";

const Header = ({}) => {
	const classes = useStyles();
	const userBalance = useSelector((state) => (state?.profile?.balance || 0));

	return (
		<div className={classes.root}>
			<div className={classes.header}>
				<Link to="/" className={classes.headerLogo}>
					<img src={require('../../../assets/svg/logos/logo-full-dark.svg').default}/>
				</Link>
				<div className={classes.headerBalance}>
					<span>{getTrans('header.Баланс')}</span>
					{rateConvert(userBalance, {useSybmol: true, decimalCount: 2})}
					<IconButton color="primary" component={Link} to="/top-up-balance">
						<AddCircleIcon/>
					</IconButton>
				</div>
			</div>

			{Boolean(false) && (
				<div className={classes.navigation}>
					<Grid container spacing={1}>
						<Grid item xs={4}>
							<Button variant="contained" fullWidth className={classes.navigationButton}>{getTrans('header.Активация')}</Button>
						</Grid>
						<Grid item xs={4}>
							<Button variant="contained" fullWidth className={classes.navigationButton}>{getTrans('header.Аренда')}</Button>
						</Grid>
						<Grid item xs={4}>
							<Button variant="contained" fullWidth className={classes.navigationButton}>{getTrans('header.Аккаунты')}</Button>
						</Grid>
					</Grid>
				</div>
			)}
		</div>
	)
}

const useStyles = makeStyles((theme) => ({
	root: {
		height: 48,
		background: theme.palette.header.default,
	},

	header: {
		padding: "12px",
		display: "flex",
		alignItems: "center",
		boxSizing: "border-box",
		justifyContent: "space-between",
	},
	headerLogo: {
		display: "flex",
		alignItems: "center",
		"& img": {
			maxWidth: "100%",
			objectFit: "contain",
			objectPosition: "left center",
		}
	},
	headerBalance: {
		gap: "6px",
		display: "flex",
		marginTop: "-4px",
		alignItems: "center",

		fontSize: 18,
		fontWeight: "600",
		lineHeight: "24px",
		color: theme.palette.text.main,

		"& span": {
			opacity: "0.3",
			fontWeight: "500",
			color: theme.palette.text.primary,
		},
		"& .MuiButtonBase-root": {
			padding: 0,
			width: 24, height: 24,
		}
	},

	navigation: {
		padding: "0 12px",
		overflow: "hidden",
		position: "relative",
	},
	navigationButton: {
		height: 36,
		padding: 0,
		borderRadius: "8px",
		background: "rgba(255,255,255,0.05)",
		border: "1px solid rgba(255,255,255,0.05)",

		fontSize: 16,
		lineHeight: 20,
		fontWeight: "500",
		color: theme.palette.text.primary,

		"&:focus,&:active,&:hover": {
			backgroundColor: "rgba(255,255,255,0.1)",
		}
	},
}));

export default Header
